import { render, staticRenderFns } from "./AboutWayPage.vue?vue&type=template&id=28b0f2d9&scoped=true&"
import script from "./AboutWayPage.vue?vue&type=script&lang=js&"
export * from "./AboutWayPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b0f2d9",
  null
  
)

export default component.exports